// The shop's own words about what it sells, written for the searches people
// actually type: Arabic perfumes, oud colognes and colonias in Puerto Rico.
export default function PerfumeSeoCopy() {
  return (
    <section className="border-t border-white/10 py-12 sm:py-16" aria-labelledby="perfumeria-about">
      <p className="text-[10px] font-bold uppercase tracking-[.24em] text-[#BBDCE9]">Puerto Rico · Fragrance</p>
      <h2 id="perfumeria-about" className="mt-3 max-w-[24ch] font-display text-3xl font-medium tracking-[-.05em] sm:text-4xl">
        Arabic perfumes and colognes, in Puerto Rico.
      </h2>
      <div className="mt-6 grid gap-6 sm:grid-cols-2 sm:gap-10">
        <p className="text-sm leading-7 text-white/60">
          Perfumeria PR carries Arabic perfumes and colognes — Lattafa, Fragrance World, Grandeur and more — alongside
          designer-inspired scents where noted. Every bottle has a clearly displayed price, with select multi-bottle offers
          shown when available. Browse actual inventory before sending an order request.
        </p>
        <p className="text-sm leading-7 text-white/60">
          Searching for perfumes árabes, oud, colonias or a cologne that lasts through a night out in San Juan? Start with
          the notes: sweet and ambery, fresh and citrus, or deep woody oud. Not sure which one is yours? Ask, and we will
          point you to the closest match.
        </p>
      </div>
      <ul className="mt-8 flex flex-wrap gap-2">
        {["Perfumes árabes", "Lattafa en Puerto Rico", "Oud colognes", "Men’s colognes", "Designer-inspired fragrances", "Unisex fragrances", "Colonias árabes", "Puerto Rico pickup & delivery"].map((tag) => (
          <li key={tag} className="rounded-full border border-white/15 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[.12em] text-white/60">
            {tag}
          </li>
        ))}
      </ul>
    </section>
  );
}